import React from "react"
import NonStretchedImage from "gatsby-theme-blank/src/components/Image/non-stretched-image"
import { accesDirectItemDescription } from "../acces-direct.module.scss"
import PropTypes from "prop-types"
import { AccesDirectItemDescription } from "./acces-direct-item-styled"
import ProcessedLink from "gatsby-theme-blank/src/components/processed-link"

const AccesDirectItem = ({ accesDirect }) => {
  let image = ""
  if (
    accesDirect.relationships.image_direct_link.localFile.extension === "svg"
  ) {
    image = (
      <img
        src={
          accesDirect.relationships.image_direct_link.localFile
            .SlugifiedPublicUrl
        }
        alt={accesDirect.image_direct_link.alt || ""}
        aria-hidden={true}
      />
    )
  } else if (accesDirect.relationships?.image_direct_link?.localFile) {
    image = (
      <NonStretchedImage
        {...accesDirect.relationships.image_direct_link.localFile}
        ariaHidden={true}
      />
    )
  }
  return (
    <>
      <ProcessedLink link={accesDirect.url.uri}>
        <div>{image}</div>
        <AccesDirectItemDescription className={accesDirectItemDescription}>
          {accesDirect.name}
        </AccesDirectItemDescription>
      </ProcessedLink>
    </>
  )
}

AccesDirectItem.propTypes = {
  accesDirect: PropTypes.object.isRequired,
}

export default AccesDirectItem
